
import LikeShapes from "../../../assets/filled/LikeShapes.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LikeShapesIcon({ className, dataTestid = "LikeShapesIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LikeShapes data-testid={dataTestid} className={classes} {...rest} />
  );
}
